var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.noUpdated)?_c('div',[_c('SearchRep'),_c('UpdateRep',{attrs:{"obj-rep":this.$store.state.repData}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }